module.exports = __webpack_public_path__ + "img/csca-icon-gold.28794eed.svg";